import { browserId, BrowserOrServerId, idString } from 'Browser/BrowserId';
import {SiteType} from 'Common/SiteType';

export type SiteKey = string;


export class SiteBasics<EitherId extends BrowserOrServerId>
{
	constructor(
		readonly id:EitherId,
		readonly type:SiteType,
		readonly key:SiteKey,
		readonly hostUrl: string,
		// Origin to prefix relative asset URLs with (e.g. when admin renders a venue's poster,
		// the assets live on the venue host, not the admin origin serving the page). Empty
		// means relative URLs — the default everywhere except admin/PosterDesignPage.
		readonly assetHost: string = ''
	)
	{ }
}

export function convertSiteId(site:SiteBasics<BrowserOrServerId>)
{
	return {...site, id: browserId(idString(site.id))};
}

